import React from 'react';
import UserActions from '../components/Users/UserActions';

const UsersPage = () => {
  return (
    <div className="container py-4">
      <div className="card shadow-lg p-4 border-0">
        <UserActions />
      </div>
    </div>
  );
};

export default UsersPage;
